import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses } from "../../utils/siteUtils";
import { BackgroundImage, BodyText, Icon, Dropdown } from "../../elements";
import PrimaryButton from "../../elements/primary-button";
import { apiAsia } from "../../utils/api-asia";
import { mobileIs } from "../../utils/siteUtils";
import { Link } from "react-router-dom";
import { gtag } from "../../utils";
import "./style.scss";
// let newslist = []
const NewsList = props => {
	const { lang, rendering, fields, page } = props;
  const { options, pc_title, m_title, placeholder, buttonText, colorScheme, iconName } = fields;
  const isMobile = mobileIs()
  const isAR = page?.fields?.rtl?.value;

  const getNewsOptions = () => {
    let newArr = [];
    (options || []).map(item => {
    	let newitem = {}
	 		newitem.code = item?.fields?.value?.value;
	 		newitem.value = item?.fields?.text?.value;
      newArr.push(newitem);
      return null;
    });
    return newArr;
  }
  const [newsOptions, setNewsOptions] = useState(() => getNewsOptions());
  const [pageIndex, setPageIndex] = useState(1);
  let num = isMobile ? 6 : 9
  const [pageSize, setPageSize] = useState(num)
  const [total, setTotal] = useState(0);
  const [showButton, setShowButton] = useState(false);
  const [newsList, setNewsList] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

 	const newsProps = {
    placeholder: placeholder.value,
    options: newsOptions,
    selectedOption: newsOptions[0],
    async onChange(option) {
    	setNewsList([])
    	setPageIndex(1)
    	setSelectedOption(option?.code)
    }
  };

  const showMore = () => {
    gtag('event', 'Component_info', {
      'component_name': 'News',
      'page_title': page?.name
    });
  	setPageIndex(pageIndex + 1)
    let year = '';
    if (selectedOption) {
      year = selectedOption;
    }
    let size = pageSize * pageIndex;
    if (size > total || size === total) {
      setShowButton(false)
    }
  }

  const getNewsList = async (year, pageIndex, pageSize) => {
    apiAsia.news.list({
    	year: year,
      page: pageIndex,
      size: pageSize,
      lang: lang
    }).then(res => {
      if (!!res[0]) {
        let newslist = JSON.parse(JSON.stringify(newsList))
      	if(res[0].DataList && res[0].DataList.length > 0) {
      		res[0].DataList.forEach((item) => {
            item.title = {
              value: isMobile ? item.m_title : item.pc_title
            }
		        newslist.push(item);
		      });
      	}
        setTotal(res[0].Total)
        let size = pageSize * pageIndex;
        if (res[0].Total > size) {
          setShowButton(true)
        } else {
          setShowButton(false)
        }
      	setNewsList(newslist)
      }
    })
    .catch(err => {
      //
    });
  };

  const goDetail = (e, path) => {
    gtag('event', 'Component_info', {
      'component_name': 'News',
      'page_title': page?.name
    });
  	let a = document.createElement('a')
    a.setAttribute('href', path)
    document.body.appendChild(a)
    a.click()
  }

  useEffect(() => {
  	getNewsList(selectedOption, pageIndex, pageSize)
  }, [selectedOption, pageIndex, pageSize])

  const rootClasses = classNames("c-news-list__space", getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource}>
    	<div className="c-news-list__space-top">
    		{!isMobile && pc_title?.value && <RichText tag="div" className="c-news-list__space-pcTitle" field={pc_title} />}
    		{isMobile && m_title?.value && <RichText tag="div" className="c-news-list__space-mobileTitle" field={m_title} />}
    		<div className="c-news-list__space-dropdown">
    			<Dropdown {...newsProps} />
    		</div>
    	</div>
    	<div className="c-news-list__space-news-content">
    	 	{newsList && newsList.length > 0 && newsList.map((item, index) => (
  				<div className={["c-news-list__space-news", index % 3 === 2 ? 'c-news-list__space-news-right' : ''].join(' ')} key={item.id} onClick={(e) => goDetail(e, item.path)}>
  					<div className="c-news-list__space-image-content">
  						<div className="c-news-list__space-image" style={{backgroundImage: `url(${item.image})`}}></div>
  					</div>
            <RichText tag="div" className="c-news-list__space-news-title" field={item.title} />
						<div className="c-news-list__space-news-date">{item.date}</div>
  				</div>
    		))}
    	</div>
    	{showButton && <div className="c-news-list__space-button-content" onClick={showMore}>
    		<PrimaryButton {...{
        	buttonText: buttonText,
		      colorScheme: colorScheme,
		      iconName: iconName
        }} />
    	</div>}
    </div>
  );
};

export default 	NewsList;